import { ReturnVerificationItemResult } from "@redotech/cockroachdb-codegen/tables/return-verification-item-result";
import { ReturnVerificationResult } from "@redotech/cockroachdb-codegen/tables/return-verification-result";
import * as z from "zod";

const verificationItemPhotoSchema = z.object({
  url: z.string(),
  note: z.string().optional(),
});

const verificationItemProductSchema = z.object({
  id: z.string(),
  /**
   * Source-system product id (e.g. Shopify product GID). Used to build a
   * Shopify admin link in the same way the declared return-item row does.
   */
  sourceId: z.string().nullable(),
  title: z.string(),
  sku: z.string().nullable(),
  imageUrl: z.string().nullable(),
});

const verificationItemSchema = z.object({
  returnItemId: z.string().nullable(),
  inventoryItemId: z.string().nullable(),
  product: verificationItemProductSchema.nullable(),
  kind: z.enum(["declared", "undeclared", "unknown"]),
  result: z.enum(ReturnVerificationItemResult).nullable(),
  photos: z.array(verificationItemPhotoSchema).nullable(),
  notes: z.string().nullable(),
});

const verificationRecordSchema = z.object({
  lifecycleStage: z.enum(["return_point", "warehouse"]),
  result: z.enum(ReturnVerificationResult).nullable(),
  performedAt: z.string(),
  items: z.array(verificationItemSchema),
});

export const getReturnVerification = {
  name: "getReturnVerification" as const,
  input: z.object({ returnId: z.string() }),
  output: z.object({ verification: verificationRecordSchema.nullable() }),
};

export type VerificationItem = z.infer<typeof verificationItemSchema>;
export type VerificationItemProduct = z.infer<
  typeof verificationItemProductSchema
>;
export type VerificationRecord = z.infer<typeof verificationRecordSchema>;
